module.exports = __webpack_public_path__ + "static/media/payu.aac8749b.svg";